import { render } from "./offerStyle.vue?vue&type=template&id=96cc6e00"
import script from "./offerStyle.vue?vue&type=script&lang=js"
export * from "./offerStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__